// extracted by mini-css-extract-plugin
module.exports = {"list":"list___m7fzQ"};